import React, { Component } from "react";
import { connect } from "react-redux";

import { Menu, Dropdown, Icon } from "antd";

class User extends Component {
  render() {
    const menu_user = (
      <Menu>
        <Menu.Item>
          <a onClick={this.props.logoutfn} className="menu__item">
            Sair
          </a>
        </Menu.Item>
      </Menu>
    );

    return (
      <Dropdown overlay={menu_user} overlayClassName="header__dropdown">
        <div className="header__user">
          <Icon
            type="user"
            style={{
              height: "16px",
              width: "16px",
              marginRight: "8px"
            }}
          />{" "}
          <div className="user__infos">
            <div>{localStorage.getItem("auth_username")}</div>
            {this.props.permissions.group != "---" ? (
              <div className="user__group">{this.props.permissions.group}</div>
            ) : null}
          </div>
        </div>
      </Dropdown>
    );
  }
}

export default connect(state => state)(User);



// WEBPACK FOOTER //
// ./src/components/Header/User/index.js